// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/logout-dialog.svg';

export const LogoutDialog = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox={false} {...props} />
);
